import axios from "axios";
import { UrlFilterHelper } from "../_helpers/UrlFilterHelper";

const API_URL = process.env.REACT_APP_API_URL;
const AREA_DAF = API_URL + "/daf/";

const DAFUPLOAD_BASEURL = AREA_DAF + "dafUpload/";
const DAFTABREQUEST_BASEURL = AREA_DAF + "dafTabRequest/";

const DAFUPLOAD_SAVEFILE_URL = DAFUPLOAD_BASEURL + "save";

const DAFUPLOADLIST_URL = DAFUPLOAD_BASEURL + "GetDafUploadList";
const DAFUPLOAD_DOWNLOADLOG_URL = DAFUPLOAD_BASEURL + "DownloadLog";
const DAFUPLOAD_DOWNLOAD_PROCESSRESULTFILE_URL = DAFUPLOAD_BASEURL+"DownloadProcessResult";
const DAFTABREQUEST_GET_TABONE_URL =
  DAFTABREQUEST_BASEURL + "GetTabOneRequests";
const DAFTABREQUEST_GET_TABTWO_URL =
  DAFTABREQUEST_BASEURL + "GetTabTwoRequests";
const DAFTABREQUEST_GET_TABTHREE_URL =
  DAFTABREQUEST_BASEURL + "GetTabThreeRequests";

export const DafUploadApi = {
  saveFile,
  getDafUploadList,
  getTabOneRequests,
  getTabTwoRequests,
  getTabThreeRequests,
  downloadLog,
  downloadProcessResultFile
};

function saveFile(data) {
  return axios.post(DAFUPLOAD_SAVEFILE_URL, data);
}

function getDafUploadList(skipCount, sorting, dsc, size, filter) {
  var url = UrlFilterHelper.GetFilterdUrl(
    DAFUPLOADLIST_URL,
    skipCount,
    filter.search,
    sorting,
    dsc,
    size
  );
  return axios.get(url); // Returns: PagedResultDto<DafUploadDto>
}

function getTabOneRequests(dafUploadId, skipCount, sorting, dsc, size) {
  return getTabRequests(
    DAFTABREQUEST_GET_TABONE_URL,
    dafUploadId,
    skipCount,
    sorting,
    dsc,
    size
  );
  // Returns: PagedResultDto<DafTabOneRequestDto>
}

function getTabTwoRequests(dafUploadId, skipCount, sorting, dsc, size) {
  return getTabRequests(
    DAFTABREQUEST_GET_TABTWO_URL,
    dafUploadId,
    skipCount,
    sorting,
    dsc,
    size
  );
  // Returns: PagedResultDto<DafTabTwoRequestDto>
}

function getTabThreeRequests(dafUploadId, skipCount, sorting, dsc, size) {
  return getTabRequests(
    DAFTABREQUEST_GET_TABTHREE_URL,
    dafUploadId,
    skipCount,
    sorting,
    dsc,
    size
  );
  // Returns: PagedResultDto<DafTabThreeRequestDto>
}

function getTabRequests(actionUrl, dafUploadId, skipCount, sorting, dsc, size) {
  var url = UrlFilterHelper.GetFilterdUrl(
    actionUrl,
    skipCount,
    null,
    sorting,
    dsc,
    size
  );
  url += "&dafUploadId=" + dafUploadId;

  return axios.get(url);
}

function downloadLog(dafUploadId) {
  var url = DAFUPLOAD_DOWNLOADLOG_URL + "/" + dafUploadId;
  return axios.get(url, { responseType: "blob" });
}

function downloadProcessResultFile(dafUploadId){
  var url = DAFUPLOAD_DOWNLOAD_PROCESSRESULTFILE_URL + "/" + dafUploadId;
  return axios.get(url, { responseType: "blob" });
}
